/* eslint-disable react/prop-types */
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import ReactVisibilitySensor from 'react-visibility-sensor';

import getSelectedFilters from '@src/containers/Filters/selectors/getSelectedFilters';
import useMainFiltersVisibility from '@src/containers/Filters/hooks/useMainFiltersVisibility';
import useHandleManageFiltersClick from '@src/libs/hooks/useHandleManageFiltersClick';
import useHandleFilterDelete from '@src/libs/hooks/useHandleFilterDelete';

import TagFilters from '../component';

const TagFiltersCDefault = (props) => {
	const filters = useSelector(getSelectedFilters);

	const { handleManageFiltersClick } = useHandleManageFiltersClick();
	const { handleFilterDelete } = useHandleFilterDelete();
	const { setMainFiltersVisibility } = useMainFiltersVisibility();

	const [headerOffsetHeight, setHeaderOffsetHeight] = useState(0);

	useEffect(() => {
		setHeaderOffsetHeight(
			document.getElementById('app_header').offsetHeight,
		);
	}, []);

	const offset = useMemo(
		() => ({ top: headerOffsetHeight }),
		[headerOffsetHeight],
	);

	return (
		<ReactVisibilitySensor
			onChange={setMainFiltersVisibility}
			offset={offset}
			partialVisibility
		>
			<TagFilters
				filters={filters}
				onManageFiltersClick={handleManageFiltersClick}
				onFilterDeleteClick={handleFilterDelete}
				wrapId="tag-filter"
				{...props}
			/>
		</ReactVisibilitySensor>
	);
};

export default TagFiltersCDefault;
